import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { isMobile } from '../Utilities/Helpers';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../Styles/Header.css';

function Header(props) {
	const { language, availableLanguages, searchParams } = props;

	const dropdownList = () => {
		return Object.entries(availableLanguages).map((langData) => {
			let id = langData[0];
			let name = langData[1];

			// Get current search params and replace the language value
			let params = new URLSearchParams(searchParams.toString());
			params.set('lang', id);
			let url = `?${params.toString()}`;

			return (
				<Dropdown.Item href={url} key={id}>{name}</Dropdown.Item>
			);
		});
	}

	const mapTitle = language && language['map:title'] ? language['map:title'] : '';

	return (
		<div className="header-wrapper">
			<div className="header-flex-wrapper">
				<div className="header-map-title">{mapTitle}</div>
			</div>

			<div className="header-spacer"></div>

			<Dropdown>
				<Dropdown.Toggle className="dropdown-button">
					{(language) ? ((isMobile()) ? language['language:short'] : language['language:name']) : 'English'}
				</Dropdown.Toggle>
				<Dropdown.Menu renderOnMount={true}>
					{(availableLanguages) ? dropdownList() : null}
				</Dropdown.Menu>
			</Dropdown>
		</div>
	)
}

export default Header;
